import { Link } from 'react-router-dom';
import ArticleLayout from '../components/ArticleLayout';
import { categories } from '@/mocks/categories';

const faqItems = [
  { question: 'Qual è la categoria più popolare su Itaobuy Spreadsheet?', answer: 'La categoria Shoes è la più popolare con oltre 5.000 prodotti e il maggior numero di recensioni. Seguono Hoodies/Sweaters e T-Shirts.' },
  { question: 'Posso suggerire nuove categorie?', answer: 'Sì, la community di Itaobuy Spreadsheet è sempre aperta a suggerimenti. Le categorie vengono periodicamente riviste in base alle richieste degli utenti.' },
];

export default function CategoriePage() {
  return (
    <ArticleLayout
      title="Itaobuy Spreadsheet Categorie: Guida Completa a Tutte le 14 Sezioni"
      description="Esplora tutte le 14 categorie di Itaobuy Spreadsheet: Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes e Other Stuff."
      tag="Categorie"
      slug="itaobuy-spreadsheet-categorie"
      faqItems={faqItems}
    >
      <div className="bg-accent-50 border border-accent-200/50 rounded-xl p-6 mb-12">
        <p className="text-sm font-semibold text-accent-800 mb-2 font-label">TL;DR &mdash; 14 Categorie, Infinite Possibilità</p>
        <p className="text-sm text-accent-700 leading-relaxed">
          <strong>Itaobuy Spreadsheet</strong> organizza oltre 15.420 prodotti in 14 categorie ben strutturate. Dalle scarpe
          ai profumi, ogni categoria è ottimizzata per offrirti la migliore esperienza di shopping.
        </p>
      </div>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Panoramica di Tutte le 14 Categorie</h2>
        <p className="text-foreground-700 leading-relaxed mb-6">
          Ogni categoria di <strong>Itaobuy Spreadsheet</strong> è stata pensata per coprire una specifica area
          dello shopping online. Ecco una panoramica completa con i punti di forza di ciascuna.
        </p>

        <div className="space-y-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-xl p-4 hover:border-primary-200 transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-secondary-700">{idx + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors">{cat.name}</p>
              </div>
              <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Le Categorie Più Popolari</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
              <i className="ri-footprint-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">Shoes</h3>
            <p className="text-sm text-foreground-600">La categoria più ampia con oltre 5.000 modelli tra sneakers, running, casual e formali.</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
              <i className="ri-t-shirt-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">Hoodies/Sweaters</h3>
            <p className="text-sm text-foreground-600">In rapida crescita con felpe oversize, zip-up e crewneck per ogni stagione.</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
              <i className="ri-shirt-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">T-Shirts</h3>
            <p className="text-sm text-foreground-600">Design grafici, vintage wash e basici essenziali con ottimo rapporto qualità-prezzo.</p>
          </div>
        </div>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Come Scegliere la Categoria Giusta</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          Se non sai da dove iniziare, ti consiglio di partire dalla categoria che conosci meglio. Se sei un appassionato
          di scarpe, Shoes è il punto di partenza ideale. Se preferisci l&apos;abbigliamento, Hoodies e T-Shirts offrono
          un&apos;ottima selezione. Per approfondire, consulta la <Link to="/articoli/itaobuy-spreadsheet-per-principianti" className="text-primary-600 hover:text-primary-700">guida per principianti</Link>.
        </p>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Conclusione</h2>
        <p className="text-foreground-700 leading-relaxed">
          Con 14 categorie ben organizzate, <strong>Itaobuy Spreadsheet</strong> copre praticamente ogni esigenza
          di shopping. Torna alla <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">home</Link> per
          esplorare subito tutte le categorie.
        </p>
      </section>
    </ArticleLayout>
  );
}